import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/shell";
import { ShellWidthProvider } from "@/components/layout/shell-width";
import { AuthProvider } from "@/lib/auth";

export const rootRoute = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AuthProvider>
      <ShellWidthProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </ShellWidthProvider>
    </AuthProvider>
  );
}
